(ns frontend.ui.page.lp-report-editor.step-1-initialization.card.basic-config
  (:require
   [clojure.data :as data]
   [clojure.string :as string]
   [common.localization :as loc]
   [frontend.ui.component.card.view :as card]
   [frontend.ui.component.grid.view :as grid]
   [frontend.ui.component.icon.view :as icon-view]
   [frontend.ui.component.modal-dialog.view :as modal-dialog]
   [frontend.ui.component.select-input-group.view :refer [select-input-group]]
   [frontend.ui.component.text-group.view :as text-group]
   [frontend.ui.component.text-input-group.view :refer [text-input-group]]
   [frontend.ui.page.lp-report-editor.common.style :as common-style]
   [frontend.ui.page.lp-report-editor.common.view :as common-view]
   [frontend.ui.page.lp-report-editor.event :as editor-event]
   [frontend.ui.page.lp-report-editor.step-1-initialization.event :as event]
   [frontend.ui.page.lp-report-editor.step-1-initialization.sub :as sub]
   [frontend.ui.page.lp-report-editor.sub :as editor-sub]
   [frontend.utils :as fu]
   [herb.core :refer [<class]]
   [re-frame.core :as rf]
   [ui.components.button.view :as button]))

(def basic-step-attributes
  [:db/id
   :lp-report/template-type
   :lp-report/title
   :lp-report/text-contributors
   :lp-report/data-contributors
   :lp-report/process-owners
   :lp-report/final-approver
   :lp-report/followers
   :lp-report/data-approver
   :lp-report/text-approver])

(defn template-type-view
  [report edit-mode? basic-config]
  (let [fund-templates @(rf/subscribe [::editor-sub/fund-templates])]
    (if edit-mode?
      [select-input-group
       {:title     (loc/tr :lp-report/template-type)
        :value     (:lp-report/template-type basic-config)
        :on-change #(rf/dispatch [::event/basic-change :lp-report/template-type %])}
       (->> fund-templates
            (sort-by second))]
      [text-group/text-group
       (loc/tr :lp-report/template-type)
       (get (into {} fund-templates) (:lp-report/template-type report) " ")])))

(defn title-view
  [report edit-mode? basic-config]
  (let [report @(rf/subscribe [::editor-sub/lp-report])]
    (if edit-mode?
      [text-input-group
       {:title     (loc/tr :lp-report/title)
        :value     (:lp-report/title basic-config)
        :on-change #(rf/dispatch [::event/basic-change :lp-report/title %])}]
      [text-group/text-group
       (loc/tr :lp-report/title)
       (get report :lp-report/title " ")])))

(defn fund-text-contributors-view
  [report edit-mode? basic-config]
  (let [contributors @(rf/subscribe [::editor-sub/text-contributors])]
    (if edit-mode?
      [select-input-group
       {:title     (loc/tr :lp-report/text-contributors)
        :multi?    true
        :value     (get basic-config :lp-report/text-contributors #{})
        :on-change #(rf/dispatch [::event/basic-change :lp-report/text-contributors %])}
       contributors]
      [text-group/text-group
       (loc/tr :lp-report/text-contributors)
       (some->> (get report :lp-report/text-contributors)
                (keep contributors)
                (string/join ", "))])))

(defn fund-data-contributors-view
  [report edit-mode? basic-config]
  (let [contributors @(rf/subscribe [::editor-sub/data-contributors])]
    (if edit-mode?
      [select-input-group
       {:title     (loc/tr :lp-report/data-contributors)
        :multi?    true
        :value     (get basic-config :lp-report/data-contributors #{})
        :on-change #(rf/dispatch [::event/basic-change :lp-report/data-contributors %])}
       contributors]
      [text-group/text-group
       (loc/tr :lp-report/data-contributors)
       (some->> (get report :lp-report/data-contributors)
                (keep contributors)
                (string/join ", "))])))

(defn followers-view
  [report edit-mode? basic-config]
  (let [contributors @(rf/subscribe [::editor-sub/followers])]
    (if edit-mode?
      [select-input-group
       {:title     (loc/tr :lp-report/followers)
        :multi?    true
        :value     (get basic-config :lp-report/followers #{})
        :on-change #(rf/dispatch [::event/basic-change :lp-report/followers %])}
       contributors]
      [text-group/text-group
       (loc/tr :lp-report/followers)
       (some->> (get report :lp-report/followers)
                (keep contributors)
                (string/join ", "))])))

(defn process-owners-view
  [report edit-mode? basic-config]
  (let [owners @(rf/subscribe [::editor-sub/report-owners])]
    (if edit-mode?
      [select-input-group
       {:title     (loc/tr :lp-report/process-owners)
        :multi?    true
        :value     (get basic-config :lp-report/process-owners #{})
        :on-change #(rf/dispatch [::event/basic-change :lp-report/process-owners %])}
       owners]
      [text-group/text-group
       (loc/tr :lp-report/process-owners)
       (some->> (get report :lp-report/process-owners)
                (keep owners)
                (string/join ", "))])))

(defn approver-view
  [report edit-mode? basic-config]
  (let [approvers @(rf/subscribe [::editor-sub/final-approvers])]
    (if edit-mode?
      [select-input-group
       {:title     (loc/tr :lp-report/final-approver)
        :value     (get basic-config :lp-report/final-approver)
        :on-change #(rf/dispatch [::event/basic-change :lp-report/final-approver %])}
       approvers]
      [text-group/text-group
       (loc/tr :lp-report/final-approver)
       (get approvers (:lp-report/final-approver report) " ")])))

(defn text-approver-view
  [report edit-mode? basic-config]
  (let [approvers @(rf/subscribe [::editor-sub/text-approvers])]
    (if edit-mode?
      [select-input-group
       {:title     (loc/tr :lp-report/text-approver)
        :value     (get basic-config :lp-report/text-approver)
        :on-change #(rf/dispatch [::event/basic-change :lp-report/text-approver %])}
       approvers]
      [text-group/text-group
       (loc/tr :lp-report/text-approver)
       (get approvers (:lp-report/text-approver report) " ")])))

(defn data-approver-view
  [report edit-mode? basic-config]
  (let [approvers @(rf/subscribe [::editor-sub/data-approvers])]
    (if edit-mode?
      [select-input-group
       {:title     (loc/tr :lp-report/data-approver)
        :value     (get basic-config :lp-report/data-approver)
        :on-change #(rf/dispatch [::event/basic-change :lp-report/data-approver %])}
       approvers]
      [text-group/text-group
       (loc/tr :lp-report/data-approver)
       (get approvers (:lp-report/data-approver report) " ")])))

(defn tools
  [edit-mode?]
  (let [can-edit? @(rf/subscribe [::sub/can-edit? :step-1])
        collapsed? @(rf/subscribe [::sub/collapsed? :step-1])]
    (concat []
            (when (and (not edit-mode?)
                       can-edit?)
              [[icon-view/icon
                {:class    (<class (fn []
                                     {:margin-right "6px"}))
                 :on-click (fn [e]
                             (fu/prevent-default-event! e)
                             (rf/dispatch [::event/start-basic-edit]))}
                :edit]])
            (when-not edit-mode?
              [[icon-view/icon
                {:on-click (fn [e]
                             (fu/prevent-default-event! e)
                             (rf/dispatch [::event/toggle-collapse :step-1]))}
                (if collapsed?
                  :angle-down
                  :angle-up)]]))))

(defn footer
  [report basic-config]
  (let [old-state (select-keys report basic-step-attributes)
        new-state (select-keys basic-config basic-step-attributes)
        [removed added _common] (data/diff old-state new-state)
        changes? (or (seq removed)
                     (seq added))]
    [:div
     {:class (<class common-style/footer-right)}
     (when-let [visible? @(rf/subscribe [::sub/change-template-dialog-visible?])]
       [modal-dialog/confirm-dialog
        {:visible?           visible?
         :hide!              #(rf/dispatch [::event/hide-change-template-dialog])
         :header-label       (loc/tr :confirm-lp-report-template-change-dialog-title)
         :confirm-text       (loc/tr :confirm-lp-report-template-change-dialog-text)
         :ok-button-text     (loc/tr :ok)
         :cancel-button-text (loc/tr :cancel)
         :on-confirm         #(rf/dispatch [::editor-event/update-lp-report old-state new-state
                                            [::event/close-edit-mode :step-1]])
         :on-cancel          (fn [_]
                               (rf/dispatch [::event/basic-change
                                             :lp-report/template-type
                                             (:lp-report/template-type report)])
                               (rf/dispatch [::event/hide-change-template-dialog]))}])
     [:div
      {:class (<class common-style/spacing-right)}
      [button/secondary-hollow
       {:on-click (fn [e]
                    (fu/prevent-default-event! e)
                    (rf/dispatch [::event/close-edit-mode :step-1])
                    (rf/dispatch [::event/reset-basic-config]))}
       (loc/tr :cancel)]]
     [button/primary-solid
      {:disabled? (not changes?)
       :on-click  (fn [_]
                    (if (and (:lp-report/template-type report)
                             (some #{:lp-report/template-type} added))
                      (rf/dispatch [::event/start-change-template-type])
                      (rf/dispatch [::editor-event/update-lp-report old-state new-state
                                    [::event/basic-change-completed]])))}
      (loc/tr :save)]]))

(defn view
  []
  (let [collapsed? @(rf/subscribe [::sub/collapsed? :step-1])
        edit-mode? @(rf/subscribe [::sub/edit-mode? :step-1])
        step-completed? @(rf/subscribe [::sub/step-complete? :step-1])
        report @(rf/subscribe [::editor-sub/lp-report])
        basic-config @(rf/subscribe [::sub/basic-config])]
    [card/card-with-tools
     {:collapsed?       collapsed?
      :toggle-collapsed #(rf/dispatch [::event/toggle-collapse :step-1])
      :icon             (if step-completed?
                          [common-view/icon-step-done]
                          [common-view/icon-step])
      :title            (loc/tr :lp-report-editor-step-1-title)
      :tool-icons       (tools edit-mode?)}
     [grid/row {:align-items "center"}
      [grid/column {:span 6}
       [template-type-view report edit-mode? basic-config]]
      [grid/column {:span 6}
       [title-view report edit-mode? basic-config]]]
     [grid/row {:align-items "center"}
      [grid/column {:span 12}
       [process-owners-view report edit-mode? basic-config]]]
     [grid/row {:align-items "center"}
      [grid/column {:span 6}
       [fund-text-contributors-view report edit-mode? basic-config]]
      [grid/column {:span 6}
       [text-approver-view report edit-mode? basic-config]]]
     [grid/row {:align-items "center"}
      [grid/column {:span 6}
       [fund-data-contributors-view report edit-mode? basic-config]]
      [grid/column {:span 6}
       [data-approver-view report edit-mode? basic-config]]]
     [grid/row {:align-items "center"}
      [grid/column {:span 6}
       [approver-view report edit-mode? basic-config]]
      [grid/column {:span 6}
       [followers-view report edit-mode? basic-config]]]
     (when edit-mode?
       [footer report basic-config])]))
